export default __webpack_public_path__ + "static/media/th-ico.774ea3e0.svg";